import Vue from 'vue'
import store from './stores/news.js'
import Entry from './components/news/Entry'
import { VueMasonryPlugin } from 'vue-masonry'
import initFilters from './modules/filter-groups.js'
import InfiniteScroll from './components/InfiniteScroll'

import {
    CollectionComponent,
    ContinuousCollectionComponent,
    SyncsWithUrl,
    ResetsPage,
} from 'clockvine-vue'

Vue.use(VueMasonryPlugin)

const app = new Vue({
    el: 'main',
    store,
    data: {
        params: {
            orderBy: 'title asc',
            page: 1,
            categories: '',
            years: '',
            search: null,
        },
    },
    mounted() {
        initFilters()
    },
    methods: {
        orderby(attr) {
            if (`${attr} asc` == this.params.orderby) {
                this.params.orderBy = `${attr} desc`
            } else {
                this.params.orderBy = `${attr} asc`
            }
        },
        getClasses(i) {
            i++

            const classes = ['masonry-grid__item']

            if (i % 2 === 0) {
                classes.push('-medium')
            }

            // if (i % 4 === 0) {
            //     classes.push('-large')
            // }

            return classes.join(' ')
        },
        loadMore() {
            this.params.page += 1
        },
        clearFilters() {
            this.params.categories = ''
            this.params.years = ''
        },
    },

    mixins: [
        new SyncsWithUrl('params', {
            page: () => false,
            orderBy: 'title asc',
        }),
        new ResetsPage(),
    ],

    components: {
        newsCollection: ContinuousCollectionComponent.for('newsEntries'),
        newsCategories: CollectionComponent.for('newsCategories'),
        newsYears: ContinuousCollectionComponent.for('newsYears'),
        Entry,
        InfiniteScroll,
    },
})
